import PricingPlanDetailSection from '../../../sections/AdminDashboard/PricingPlans/PricingPlanDetail';

const PricingPlanDetail = () => <PricingPlanDetailSection />;

export default PricingPlanDetail;
